var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaLinealDerecha24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44843 19.5695C9.76293 19.8391 10.2364 19.8027 10.506 19.4882L15.8366 13.2691C16.4625 12.5389 16.4625 11.4613 15.8366 10.731L10.506 4.51199C10.2364 4.19749 9.76292 4.16107 9.44843 4.43064C9.13393 4.7002 9.09751 5.17368 9.36708 5.48817L14.3059 11.2501L2.93652 11.2501C2.52231 11.2501 2.18652 11.5859 2.18652 12.0001C2.18652 12.4143 2.52231 12.7501 2.93652 12.7501L14.3059 12.7501L9.36708 18.512C9.09752 18.8265 9.13394 19.3 9.44843 19.5695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaLinealDerecha24X24);
export default __webpack_public_path__ + "static/media/FLECHA_LINEAL_DERECHA_24X24.4e4b898ba00048d4540c47061555a514.svg";
export { ForwardRef as ReactComponent };